"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = unloader;

var _isReady = _interopRequireDefault(require("./is-ready"));

function unloader() {
  if (typeof document !== "undefined") {
    let script = document.getElementById("grecaptcha-lib");

    if (script) {
      document.body.removeChild(script);
    }

    if ((0, _isReady.default)()) {
      delete window.grecaptcha;
      script = document.querySelector('[src^="https://www.gstatic.com/recaptcha/"]');

      if (script) {
        script.parentNode.removeChild(script);
      }
    }
  }
}